export const GramIcon = (): JSX.Element => {
  return (
    // Explicit width/height + h-auto: Safari collapses an unsized svg in an
    // auto-height flex parent to 0px tall instead of deriving the aspect
    // ratio from the viewBox alone.
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 100 97"
      width="100"
      height="97"
      className="h-auto w-full"
    >
      <path
        d="M70.9355 91.3402L5.05057 81.9787L0 86.3592L70.9355 96.4351L100 71.2201L94.9557 70.5059L70.9355 91.3402Z"
        fill="#232323"
      />
      <path
        d="M70.9355 76.0554L100 50.8405L94.9557 50.1262L70.9355 70.9543L47.4273 67.6167L15.1391 63.0339L5.05057 61.599L0 65.9796L10.0948 67.4081L0 76.1629L70.9355 86.2387L100 61.0301L94.9557 60.3159L70.9418 81.1502L37.3325 76.3715L42.3767 71.9973L70.9355 76.0554Z"
        fill="#232323"
      />
      <path
        d="M70.9355 60.7648L5.05057 51.4033L0 55.7838L70.9355 65.8597L100 40.6511L94.9557 39.9368L70.9355 60.7648Z"
        fill="#232323"
      />
      <path
        d="M94.9557 19.5508L84.8609 28.3055L70.9355 40.3852L43.7042 36.5166L5.05057 31.0236L0 35.4041L38.6536 40.8909L33.6094 45.2714L5.04425 41.2132L0 45.5938L70.9355 55.6696L100 30.461L89.9052 29.0261L100 20.2651L94.9557 19.5508Z"
        fill="#232323"
      />
      <path
        d="M100 10.0759L29.0645 0L0 25.2086L70.9355 35.2908L100 10.0759Z"
        fill="#232323"
      />
    </svg>
  );
};
